/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const ListItem = ({ question, answer }) => {
  const [activeLi, setActiveLi] = useState(false);
  const [activeTitle, setActiveTitle] = useState(false);
  const [visibleAnswer, setVisibleAnswer] = useState(false);

  const handleTitleClick = event => {
    event.preventDefault();
    setActiveLi(!activeLi);
    setActiveTitle(!activeTitle);
    setVisibleAnswer(!visibleAnswer);
  };

  const handleArrowClick = event => {
    event.preventDefault();
    setActiveLi(!activeLi);
  };

  return (
    <li className={cx({ active: activeLi })}>
      <i
        className="fa fa-angle-down"
        aria-hidden="true"
        onClick={handleArrowClick}
      />
      <h2 className="title">
        <a
          className={cx({ active: activeLi })}
          href="#"
          onClick={handleTitleClick}
        >
          {question}
        </a>
      </h2>
      <p className={cx('answer', { visible: visibleAnswer })}>{answer}</p>
    </li>
  );
};

ListItem.propTypes = {
  question: PropTypes.node.isRequired,
  answer: PropTypes.node.isRequired,
};

export default ListItem;
